import { safeParse, safeParseNullDefault } from 'shouldve-been-js';

class Inspector {

    private _inspectorId: string;
    private _firstName: string;
    private _lastName: string;
    private _status: string;

    public constructor(inspectorId: string, firstName: string, lastName: string, status: string) {

        this._inspectorId = inspectorId;
        this._firstName = firstName;
        this._lastName = lastName;
        this._status = status;
    }

    public get inspectorId(): string {
        return this._inspectorId;
    }

    public set inspectorId(value: string) {
        this._inspectorId = value;
    }

    public get firstName(): string {
        return this._firstName;
    }

    public set firstName(value: string) {
        this._firstName = value;
    }

    public get lastName(): string {
        return this._lastName;
    }

    public set lastName(value: string) {
        this._lastName = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Inspector | null {

        const inspectorId: string | null = safeParseNullDefault<string>(json?.inspectorId, '');
        const firstName: string = safeParse<string>(json?.firstName, '');
        const lastName: string = safeParse<string>(json?.lastName, '');
        const status: string = safeParse<string>(json?.status, '');
        
        if (inspectorId === null || inspectorId === '') {
            return null;
        }

        return new Inspector(inspectorId, firstName, lastName, status);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): Inspector | null {

        const inspectorId: string | null = safeParseNullDefault<string>(object?._inspectorId, '');
        const firstName: string = safeParse<string>(object?._firstName, '');
        const lastName: string = safeParse<string>(object?._lastName, '');
        const status: string = safeParse<string>(object?._status, '');
        
        if (inspectorId === null || inspectorId === '') {
            return null;
        }

        return new Inspector(inspectorId, firstName, lastName, status);
    }

    public getNameString(): string {

        return this.firstName + ' ' + this.lastName;
    }
}

export default Inspector;